export default __webpack_public_path__ + "static/media/ethnio.cf05b4b8.svg";